
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCartItems } from "../Redux/shoppingCartReducer";
import "../i18n/config";
import i18next from "i18next";
import ShoppingCartItemComponent from "../ShoppingCartItem";

function CompanyShoppingCartComponent({ register, handleSubmit, errors, ...props }) {
    const [lang, setLang] = useState("");
    const location = useLocation();
    let cartItems = useSelector(selectCartItems);
    const productsFromSession = window.sessionStorage.getItem("products");
    cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;

    const SetLanguage = (l) => {
        i18next.changeLanguage(l);
    };
  
    useEffect(() => {
        setLang(new URLSearchParams(location.search).get("lang") || "eng");

    }, []);

    useEffect(() => {
        SetLanguage(lang);
    }, [lang]);

    return (
        <>
            {Object.keys(cartItems).map((k, ind) => {
                const currentItem = cartItems[k];
                const currentProduct = currentItem.selectedProduct;
                const itemCount = currentItem.qty
                return <div key={ind}>
                    <ShoppingCartItemComponent itemCount={itemCount} currentProduct={currentProduct} currentItem={currentItem} isConfirmation={props.isConfirmation} topCart={props.topCart}></ShoppingCartItemComponent>
                </div>
            })
            }
        </>
    );
}
export default CompanyShoppingCartComponent;
